export * from './share.module';
